export class GLUpdate {
  hoId: number;
  chn: string;
  div: string;
  itemNum: string;
  glCode: string;
}
